module.exports = {
      id: "game-shop-usage",
      viewBox: "0 0 48.679 33.19",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#game-shop",
      toString: function () {
        return this.url;
      }
    }